import { render } from "./ClickedFiltersTopComponent.vue?vue&type=template&id=394aa5ba&scoped=true"
import script from "./ClickedFiltersTopComponent.vue?vue&type=script&lang=js"
export * from "./ClickedFiltersTopComponent.vue?vue&type=script&lang=js"

import "./ClickedFiltersTopComponent.vue?vue&type=style&index=0&id=394aa5ba&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394aa5ba"]])

export default __exports__